const stories = [
  {
    options: {
      showParties: true,
    },
    paragraphs: [
      'Näin eri puolueiden aluevaltuutetut sijoittavat itsensä asteikolla liberaali–konservatiivi ja oikeisto–vasemmisto.',
    ],
  },
  {
    options: {
      showParties: true,
      showCompare: true,
    },
    paragraphs: [
      'Näin valituiksi tulleiden arvot eroavat ehdolla olleiden arvoista. Esimerkiksi valitut kristillisdemokraatit ovat konservatiivisempia kuin puolueen ehdokkaat.',
    ],
  },
  {
    options: {
      showScatter: true,
      region: null,
    },
    paragraphs: [
      'Näin aluevaltuutettujen arvot jakautuvat hyvinvointialueiden välillä. Yksi sydän kuvaa yhtä hyvinvointialuetta. Seuraavaksi voit perehtyä alueisiin tarkemmin.',
    ],
  },
  {
    options: {
      clickable: false,
      showScatter: true,
    },
  },
  {
    options: {
      clickable: true,
      showScatter: true,
    },
  },
]

const labels = {
  conslib: {
    '1': 'Vahvasti¤liberaali',
    '4': 'Ei¤konservatiivi¤eikä¤liberaali',
    '7': 'Vahvasti¤konservatiivi',
  },
  leftright: {
    '1': 'Vahvasti¤vasemmalla',
    '4': 'Ei vasemmalla¤eikä oikealla',
    '7': 'Vahvasti¤oikealla',
  },
  likert: {
    '1': 'Täysin¤eri mieltä',
    '2': 'Jokseenkin¤eri mieltä',
    '3': 'Jokseenkin¤samaa mieltä',
    '4': 'Täysin¤samaa mieltä',
  },
  exploreScatter: 'Valitse hyvinvointialue nähdäksesi, millaiset ovat sen aluevaltuutettujen ja alueeseen kuuluvien kuntien kunnanvaltuutettujen arvot. Sydän kuvaa uusia aluevaltuutettuja, ympyrät alueen kuntien kunnanvaltuutettuja. Näet lisätietoja painamalla sydäntä tai ympyröitä.',
  exploreQuestions: 'Nyt voit itse selata vaalikoneen vastauksia. Voit vertailla vastauksia puolueiden, kotikunnan tyypin tai sukupuolen mukaan.',
  selectRegion: 'Valitse hyvinvointialue',
  clear: 'Tyhjennä hakukenttä',
  questionsHeader: 'Lähipalvelut ja yksityiset sote-yritykset jakavat mielipiteitä',
  compare: 'Vertaa',
  parties: 'Puolueet',
  muni: 'Kotikunnan tyyppi',
  gender: 'Sukupuoli',
}

export { stories, labels };